import useCart from '@/contexts/useCart'
import { Clock } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import React from 'react'

const CartExpireTimer = () => {
  const { unlockTimer } = useCart()
  const { t } = useTranslation('experience')

  if (!unlockTimer) {
    return null
  }

  return (
    <div className="bg-stone-100 py-1 px-2 rounded-md flex items-center space-x-2 text-sm">
      <Clock size={16} />
      <span>{t('time_left')}</span>
      <strong className="text-primary ml-1">{unlockTimer}</strong>
    </div>
  )
}

export default CartExpireTimer
